/* eslint-disable react/prefer-stateless-function */
import React from "react";
import PropTypes from "prop-types";
import SimpleMap from "./SimpleMap";

class Body extends React.Component {
  render() {
    const { data } = this.props;
    const tooltipSchema = [
      {
        mainLabel: "County",
        accessor: "county",
      },
      {
        subLabel: "Access",
        accessor: "shortage",
        formatter: (x) => {
          const xClean = x.toLowerCase();
          switch (xClean) {
            case "acute":
              return "Acute desert";
            case "moderate":
              return "Moderate desert";
            default:
              return "Not a desert";
          }
        },
      },
      {
        fieldName: "Open",
        accessor: "open_programs",
      },
      {
        fieldName: "Closed",
        accessor: "permanently",
      },
      {
        fieldName: "Closed temporarily",
        accessor: "temporarily",
      },
    ];
    const legendLabels = ["No", "Moderate", "Acute"];
    return (
      <div className="body__container">
        <SimpleMap
          geoData={data.geoJson}
          csvData={data.csvData}
          csvJoinAccessor="county"
          geoJoinAccessor="NAME"
          colorAccessor="shortage"
          legendTitle="Child care desert?"
          tooltipSchema={tooltipSchema}
          legendLabels={legendLabels}
        />
      </div>
    );
  }
}

Body.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Body;
